import { render, staticRenderFns } from "./aviso-truck.vue?vue&type=template&id=815516da&scoped=true"
import script from "./aviso-truck.vue?vue&type=script&lang=js"
export * from "./aviso-truck.vue?vue&type=script&lang=js"
import style0 from "./aviso-truck.vue?vue&type=style&index=0&id=815516da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815516da",
  null
  
)

export default component.exports